<script setup lang="ts">
import { ref, computed, type PropType, onMounted } from 'vue'
import { type MemorialPrivilegeDTO } from '@/composables/life/life'
import { useRouter, useRoute } from 'vue-router'
import { isSetRealName } from '@/composables/user/users'
import { ElMessage } from 'element-plus'
import SetRealNameDialog from '@/components/business/me/SetRealNameDialog.vue'
const realNameModalRef = ref<InstanceType<typeof SetRealNameDialog> | null>(null)
const router = useRouter()
// 有无讣告
const props = defineProps({
  privilege: {
    type: Object as PropType<MemorialPrivilegeDTO | null>,
    default: () => null
  },
  canCreateObituary: {
    type: Boolean,
    default: true
  }
})

const privilege = computed(() => {
  return props.privilege
})
const canCreateObituary = computed(() => {
  return props.canCreateObituary
})
let newArticleRef = ref(null)
let newArticle = ref(false)

async function handleCreateArticle() {
  if (!isSetRealName.value) {
    const isSuccess = await realNameModalRef.value?.open()

    if (!isSuccess) {
      console.log('用户取消了实名认证，停止后续操作')
      return
    }
  }
  if (canCreateObituary.value) {
    newArticle.value = true
  } else {
    createArticle()
  }
}

function createObituary() {
  newArticle.value = false
  router.push('/CreateObituary?lifeId=' + privilege.value?.lifeId + '&serviceId=' + privilege.value?.serviceId)
}

function createArticle() {
  router.push('/createMArticle?serviceId=' + privilege.value?.serviceId + '&isEdit=false')
}
onMounted(() => {
  console.log('canCreateObituary', canCreateObituary.value)
})
// script setup
</script>

<template>
  <button
    ref="newArticleRef"
    flex
    items-center
    justify-center
    btn-outline
    class="text-theme-main hover:text-theme-dark border-theme-main hover:border-theme-dark hover:bg-theme-light"
    rounded-full
    h-10
    px-6
    py-2
    mt-4
    mx-auto
    @click="handleCreateArticle">
    <p class="i-mynaui:plus" w-6 h-6 mr-1 ml--1></p>
    <p>{{ $t('action.article') }}</p>
  </button>

  <RToolTip :wrapper-ref="newArticleRef" placement="bottom" :arrow="false" v-model="newArticle">
    <div flex flex-col items-center text-theme-main hover:text-theme-dark>
      <div
        flex="~ row"
        items-center
        quick-menu-item
        justify-start
        px-3
        pb-2
        border-b-1
        w-full
        @click="createArticle"
        cursor-pointer>
        <i i-ri:edit-line text-base></i>
        <p px-2>{{ $t('privilege.item_m_article') }}</p>
      </div>
      <div
        flex="~ row"
        items-center
        quick-menu-item
        justify-start
        px-3
        pt-2
        w-full
        @click="createObituary"
        cursor-pointer>
        <i i-codicon:note></i>
        <p px-2>{{ $t('obituary.title') }}</p>
      </div>
    </div>
  </RToolTip>
  <SetRealNameDialog ref="realNameModalRef" />
</template>
<style scoped>
/* style */
</style>
